<!--财务中心 客户结算(自录客户) 客户列表 详情-->
<template>
  <div style="width: 100%;height: 100%">
    <el-row :data="data">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>项&nbsp;&nbsp;目&nbsp;&nbsp;点：{{ data[0].PROJECT_NAME }}</li>
          <li>供&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;商：{{ data[0].SUPPLIER_NAME }}</li>
          <li>送&nbsp;货&nbsp;日&nbsp;期&nbsp;：{{ data[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>制&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;人：{{ managername }}</li>
          <li>订&nbsp;单&nbsp;编&nbsp;号&nbsp;：{{ data[0].ORDER_CODE }}</li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column label="名称" prop="SHORT_NAME" min-width="130"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价（元）"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购（kg）"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收（kg）"></el-table-column>
          <el-table-column prop="SUPPLIER_TOTAL_FEE" label="总价（元）"></el-table-column>
          <el-table-column prop="SUPPLIER_REAL_FEE" label="实收价（元）"></el-table-column>
          <el-table-column prop="GYSCATALOG_NAME" label="分类"></el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { dayDetail } from 'api/tcBanlance';

export default {
  data() {
    return {
      month: sessionStorage.getItem('MONTH'),
      managername: sessionStorage.getItem('name'),
      tableData: [],
      data: [
        {
          TC_NAME: '',
          SUPPLIER_NAME: '',
          SEND_DAY: '',
          ORDER_CODE: '',
        },
      ],
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        ORDER_ID: Number(sessionStorage.getItem('ORDER_ID')),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      dayDetail(params)
        .then((result) => {
          if (result[0].length !== 0) {
            this.tableData = result[0].DETAIL;
            this.data = result[0].TITLE;
          } else {
            this.tableData = [];
            this.data = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>
<style scoped>
.ma img {
  width: 105px
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/financeCenter/customerOrderDayList.vue